import React from 'react';
import Layout from '../components/layout/Layout';

const Impressum: React.FC = () => {
  React.useEffect(() => {
    document.title = "Impressum | OetterliApps";
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-20 mt-16">
        <h1 className="text-3xl font-bold mb-8 text-sky-800">Impressum</h1>
        
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-xl font-semibold mb-4 text-sky-700">Angaben gemäß § 5 TMG</h2>
          <p className="mb-4">
            OetterliApps<br />
            Patrick Oetterli<br />
            Sappetenstrasse 14<br />
            4416 Bubendorf<br />
            Schweiz
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">Kontakt</h2>
          <p className="mb-4">
            Telefon: +41 123 456 789<br />
            E-Mail: patrick.oetterli@gmail.com
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">Umsatzsteuer-ID</h2>
          <p className="mb-4">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            CH123456789
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p className="mb-4">
            Patrick Oetterli<br />
            Sappetenstrasse 14<br />
            4416 Bubendorf<br />
            Schweiz
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">Streitschlichtung</h2>
          <p className="mb-4">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr/" className="text-blue-600 hover:underline">https://ec.europa.eu/consumers/odr/</a>.<br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
          
          <p className="mt-8 text-sm text-gray-600">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Impressum;
